import { regionHostMixin as h, regionAdapterRegistry as a } from "@uxland/regions";
const v = (r) => h(r, a);
class l {
  constructor() {
    this.viewsByRegion = {}, this.regions = {};
  }
  registerRegion(e, t) {
    this.regions[e] = [...this.regions[e] || [], t];
  }
  unregisterRegion(e, t) {
    this.regions[e] = this.getRegionsByName(e).filter((i) => i !== t);
  }
  registerView(e, t, i) {
    const s = this.viewsByRegion[e] || [], o = s.findIndex((n) => n.key === t);
    o >= 0 ? (s[o] = { key: t, view: i }, this.viewsByRegion[e] = s) : this.viewsByRegion[e] = [...s, { key: t, view: i }];
  }
  unregisterView(e, t) {
    const i = this.viewsByRegion[e];
    i && (this.viewsByRegion[e] = i.filter((s) => s.key !== t));
  }
  getRegisteredViews(e) {
    return this.viewsByRegion[e] || [];
  }
  getRegionsByName(e) {
    return this.regions[e] || [];
  }
  destroy() {
    this.viewsByRegion = {}, this.regions = {};
  }
  clear() {
    this.viewsByRegion = {};
  }
}
class g {
  constructor(e) {
    this._viewRegistry = e, this._regions = {};
  }
  add(e, t) {
    const i = this.getRegion(e);
    if (i) {
      const s = i.host, o = t.host;
      if (s && o && s === o)
        throw s.uxlRegion = i, new Error(
          `RegionManager.add: region "${e}" already exists for the same host (idempotent rejection)`
        );
      const n = s;
      if (n)
        for (; n.firstChild; )
          n.removeChild(n.firstChild);
      this.remove(i);
    }
    return this._regions[e] = t, this._viewRegistry.registerRegion(e, t), this;
  }
  getRegion(e) {
    return this._regions[e];
  }
  remove(e) {
    let t, i = "";
    return typeof e == "string" ? (t = this.getRegion(e), i = e, delete this._regions[e]) : typeof e == "object" && (i = Object.keys(this._regions).find((s) => this._regions[s] === e), i && (t = e, delete this._regions[i])), i && t && this._viewRegistry.unregisterRegion(i, t), t;
  }
  addViewToRegion(e, t, i) {
    const s = this.getRegion(e);
    if (!s)
      throw new Error(`Couldn't find a region with name: ${e}`);
    return s.addView(t, i), this;
  }
  async registerViewWithRegion(e, t, i) {
    return this._viewRegistry.registerView(e, t, i), await Promise.allSettled(
      this._viewRegistry.getRegionsByName(e).map((s) => {
        if (!s.containsView(t))
          return s.addView(t, i);
      })
    ), this;
  }
  async unregisterViewFromRegion(e, t) {
    return this._viewRegistry.unregisterView(e, t), await Promise.allSettled(this._viewRegistry.getRegionsByName(e).map((i) => i.removeView(t))), this;
  }
  getRegisteredViews(e) {
    return this._viewRegistry.getRegisteredViews(e);
  }
  clear() {
    return Object.values(this._viewRegistry.regions).forEach((e) => {
      e?.length && Object.keys(e[0].views).forEach((t) => e[0]?.removeView(t));
    }), this;
  }
  destroy() {
    return this.clear(), Object.values(this._viewRegistry.regions).forEach(
      (e) => this.remove(e[0])
    ), this._regions = {}, this;
  }
  createRegionManager() {
    return new g(this._viewRegistry);
  }
}
class w extends g {
  constructor(e) {
    const t = new l();
    super(t), this._name = e;
  }
  clear() {
    return super.clear(), this._viewRegistry.clear(), this;
  }
  destroy() {
    return super.destroy(), this._viewRegistry.destroy(), this;
  }
}
const f = (r) => new w(r), c = (r) => r.importer(), R = async (r, e, t) => {
  try {
    const i = await c(r), s = e(r);
    return await t(s, i), {
      dispose: () => d(s, i),
      importedPlugin: i,
      apiInstance: s
    };
  } catch (i) {
    console.error(`Failed to load plugin ${r.pluginId}:`, i);
  }
}, u = async (r, e) => {
  await e.initialize(r);
}, d = (r, e) => e.dispose(r), p = async (r, e) => {
  if (!r?.length) throw new Error("No plugins to bootstrap");
  return (await Promise.allSettled(r.map((i) => R(i, e, u)))).map((i) => i.status === "fulfilled" ? i.value : null);
};
export {
  g as RegionManager,
  p as bootstrapPlugins,
  v as createRegionHost,
  f as createRegionManager
};
//# sourceMappingURL=index.js.map
